import { render, staticRenderFns } from "./NewUsersDay.vue?vue&type=template&id=1d5b8bc2&scoped=true"
import script from "./NewUsersDay.vue?vue&type=script&lang=ts"
export * from "./NewUsersDay.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5b8bc2",
  null
  
)

export default component.exports